import { jsx as _jsx } from "react/jsx-runtime";
import { Folder, Handshake, PersonAdd } from "@mui/icons-material";
import { EmptyState } from "../../shared/EmptyState";
export const ReferralEmptyState = () => {
    return (_jsx(EmptyState, { backgroundIcon: Folder, primaryIcon: Handshake, accentIcon: PersonAdd, title: "No Direct Referrals Yet", description: "When other providers refer clients to you, they will appear here. This is where you'll manage and track incoming direct referrals from your network." }));
};
